import { FC, ReactNode } from 'react';

import { DropdownOverlay, StyledDropdown } from './NavBarSearchDropdown.styles';

type Props = {
    isActive: boolean;
    onOverlayClick: () => void;
    content?: ReactNode;
    navigationBarHeight?: number;
};

export const NavBarSearchDropdown: FC<Props> = ({ isActive, onOverlayClick, content, navigationBarHeight }) => {
    return (
        <>
            <DropdownOverlay onClick={onOverlayClick} role="presentation" />
            <StyledDropdown $isActive={isActive} $navBarHeight={navigationBarHeight} aria-live="polite">
                {content}
            </StyledDropdown>
        </>
    );
};
